import {CircleLoader} from "react-spinners";
import styles from './Spinner.module.scss'

const Spinner = () => {
    return (
        <div className={styles.container}>
            <div className={styles.spinner}>
                <CircleLoader color={"#76d7ea"}/>
            </div>
        </div>
    );
}

export default Spinner;
